module.exports = __webpack_public_path__ + "static/media/introducing-utogi.68e365ac.svg";